import React, { useState } from 'react';
import axios from 'axios';
import { TextField, Button, Typography, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/signin`,
        { email, password },
        { withCredentials: true } // necessário para cookie JWT
      );


 
console.log(document.cookie);

      console.log('Resposta do backend:', response);

      if (response.status === 200) {
      localStorage.setItem("token", "ok"); // precisa disso para ProtectedRoute
    navigate("/MainLayout"); 
      } else {
        alert('Erro no login.');
      }
    } catch (error) {
      alert('Erro ao fazer login. Verifique seu email e senha.');
    }
  };

  return (
    <Container maxWidth="sm">
      <Typography variant="h4" gutterBottom>Login</Typography>
      <TextField
        fullWidth
        label="E-mail"
        margin="normal"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <TextField
        fullWidth
        type="password"
        label="Senha"
        margin="normal"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <Button
        fullWidth
        variant="contained"
        color="primary"
        onClick={handleLogin}
      >
        Entrar
      </Button>
    </Container>
  );
};

export default LoginPage;
